var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoginPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7038 7.96C10.7038 9.90201 9.09314 11.52 7.05191 11.52C5.01067 11.52 3.4 9.90201 3.4 7.96C3.4 6.01799 5.01067 4.4 7.05191 4.4C9.09314 4.4 10.7038 6.01799 10.7038 7.96ZM10.042 11.9583C9.2048 12.5628 8.17084 12.92 7.05191 12.92C4.26182 12.92 2 10.6993 2 7.96C2 5.22067 4.26182 3 7.05191 3C9.842 3 12.1038 5.22067 12.1038 7.96C12.1038 9.09831 11.7133 10.1471 11.0565 10.9841L13.4967 13.078L14.7847 11.7525L15.7888 12.7281L14.5569 13.9959L15.8123 15.0916L17.0108 13.915L17.9916 14.914L16.3307 16.5446L15.8683 16.9986L15.3801 16.5725L13.0822 14.5671L10.042 11.9583Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginPassword);
export default __webpack_public_path__ + "static/media/icon_login_password.289acd8952c8c15825d0b1691ee3712d.svg";
export { ForwardRef as ReactComponent };